module.exports = __webpack_public_path__ + "assets/coupon-blue-48a57d.svg";